import { GameActivity } from '../enum/GameActivity';

import { boolean } from 'yup';
import { PAYMENT_OPTIONS, PAYMENT_TYPE_OPTIONS } from '../constant/constants';

export const otherFiltersList = [
  {
    key: 'GameActivity',
    label: 'statisticPage.header.filter.gameActivity',
    type: 'radio',
    options: [
      {
        ID: GameActivity.ALL,
        Name: 'statisticPage.header.filter.dropdown.gameActivity.all',
      },
      {
        ID: GameActivity.WITH,
        Name: 'statisticPage.header.filter.dropdown.gameActivity.with',
      },
      {
        ID: GameActivity.WITHOUT,
        Name: 'statisticPage.header.filter.dropdown.gameActivity.without',
      },
    ],
  },
  {
    key: 'PaymentSource',
    label: 'statisticPage.header.filter.paymentSource',
    type: 'checkbox',
    options: PAYMENT_OPTIONS.map((opt) => ({
      ID: opt.ID,
      Name: opt.Name,
    })),
    hasSwitch: true,
    switchValue: boolean,
    switchLabel: 'statisticPage.header.filter.dropdown.paymentSource.sum',
  },
  {
    key: 'PaymentType',
    label: 'statisticPage.header.filter.paymentType',
    type: 'checkbox',
    options: PAYMENT_TYPE_OPTIONS.map((opt) => ({
      ID: opt.ID,
      Name: opt.Name,
    })),
  },
  {
    key: 'Games',
    label: 'statisticPage.header.filter.games',
    type: 'checkbox',
    search: true,
  },
  {
    key: 'TestData',
    label: 'statisticPage.header.filter.testData',
    type: 'radio',
    options: [
      {
        ID: true,
        Name: 'statisticPage.header.filter.dropdown.testData.yes',
      },
      {
        ID: false,
        Name: 'statisticPage.header.filter.dropdown.testData.no',
      },
    ],
  },
];
